import { createSelector } from 'reselect';
import { initialState } from './order.reducer';

const selectBoardDomain = state => state.order || initialState;

const makeSelectOrderList = () => createSelector(selectBoardDomain, substate => substate.orderList);
const makeSelectOrderListLoading = () => createSelector(selectBoardDomain, substate => substate.orderListLoading);
const makeSelectOrgOrderList = () => createSelector(selectBoardDomain, substate => substate.orgOrderList);
const makeSelectOrderType = () => createSelector(selectBoardDomain, substate => substate.orderType);

const makeSelectModalVisible = () => createSelector(selectBoardDomain, substate => substate.modalVisible);
const makeSelectModalOrderId = () => createSelector(selectBoardDomain, substate => substate.modalOrderId);

const makeSelectFilter = () => createSelector(selectBoardDomain, substate => substate.filter);
const makeSelectPhoto = () => createSelector(selectBoardDomain, substate => substate.postForm.photo);
const makeSelectPostLoading = () => createSelector(selectBoardDomain, substate => substate.postLoading);
const makeSelectUpdateStatusLoading = () => createSelector(selectBoardDomain, substate => substate.updateStatusLoading);

export {
  selectBoardDomain,
  makeSelectOrderList,
  makeSelectOrderListLoading,
  makeSelectOrgOrderList,
  makeSelectOrderType,
  makeSelectModalVisible,
  makeSelectFilter,
  makeSelectPhoto,
  makeSelectPostLoading,
  makeSelectModalOrderId,
  makeSelectUpdateStatusLoading
};
